import { useState } from 'react'

import clsx from 'clsx'

import styles from './style.module.scss'

// Kurzbeschreibungen stehen unter der Bezeichnung der Einstellung. Damit die
// linke Spalte nicht in die Höhe wächst, wird der Text zunächst gekürzt und
// lässt sich per „mehr lesen" aufklappen.
const LIMIT = 120

/**
 * Erklärung unter einer Einstellungs-Überschrift.
 *
 * Die Einstellungen tragen bislang nur einen Titel. Was eine Zahl bewirkt,
 * ließ sich nur aus dem Backend erschließen — etwa dass „Invoices overdue
 * time" die Grenze ist, ab der eine Rechnung im Dashboard und in den
 * Erinnerungen als überfällig gilt.
 *
 * Die Texte sind aus dem Code abgeleitet. Wo eine Wirkung nicht belegbar war,
 * steht das ausdrücklich dabei statt einer Vermutung.
 */
// `className` erlaubt einem Baustein, die Breite der Erklärung zu ändern —
// etwa beim Skills4Retail-Konzept, dessen Texte die ganze Karte nutzen.
export default function SettingHint({ children, example, warning, className }) {
	const [open, setOpen] = useState(false)

	// Nur Fließtext lässt sich sinnvoll kürzen. Kommt ausnahmsweise kein String,
	// wird der Inhalt unverändert gezeigt.
	const text = typeof children === 'string' ? children : null
	const isLong = text !== null && text.length > LIMIT
	const shown = !isLong || open ? children : `${text.slice(0, LIMIT).trimEnd()}…`

	return (
		<div className={clsx(styles.root, className)}>
			<p className={styles.text}>
				{shown}
				{isLong && (
					<button type="button" className={styles.toggle} onClick={() => setOpen(o => !o)}>
						{open ? 'weniger' : 'mehr lesen'}
					</button>
				)}
			</p>
			{(!isLong || open) && example && <p className={styles.example}>{example}</p>}
			{(!isLong || open) && warning && <p className={styles.warning}>{warning}</p>}
		</div>
	)
}
